<div class="shopify-nudge-card">
  <!-- New nudge view: top winning experiments, as on the main dashboard -->
  <div class="winning-card" *ngIf="useWinningExperiments">
    <div
      class="winning-card__loading"
      *ngIf="winningExperimentsLoading || hasCampaigns === null"
      role="status"
      aria-label="Loading winning experiments"
    >
      <ngx-skeleton-loader
        count="5"
        [theme]="{ height: '34px', 'margin-bottom': '10px' }"
      ></ngx-skeleton-loader>
    </div>

    <ng-container *ngIf="!winningExperimentsLoading && hasCampaigns !== null">
      <div
        class="winning-card__state"
        *ngIf="winningExperimentsError"
        role="status"
      >
        <p>Winning experiments could not be loaded.</p>
        <button
          type="button"
          class="winning-card__link"
          (click)="loadWinningExperiments()"
        >
          Try again
        </button>
      </div>

      <ng-container *ngIf="!winningExperimentsError">
        <ng-container
          *ngIf="winningExperiments.length; else noWinningExperiments"
        >
          <div class="winning-card__summary">
            <span class="winning-card__total">{{
              totalWinningExperiments | number
            }}</span>
            <span class="winning-card__total-label">
              winning
              {{ totalWinningExperiments === 1 ? "experiment" : "experiments" }}
              in this period
            </span>
          </div>

          <div class="winning-card__table">
            <table
              class="custom_table winning-experiments-table"
              aria-label="Top five nudges by positive Incremental Value"
            >
              <thead>
                <tr>
                  <th scope="col">Nudge ID</th>
                  <th scope="col">Incremental Value</th>
                  <th scope="col" title="Revenue per visit uplift">RPV</th>
                  <th scope="col" title="Conversion rate uplift">CR</th>
                  <th scope="col" title="Average order value uplift">AOV</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let experiment of winningExperiments">
                  <td>{{ experiment.nudgeId }}</td>
                  <td>
                    <div class="percentage positive">
                      {{ experiment.incrementalValue | currencyFormatter }}
                    </div>
                  </td>
                  <td *ngFor="let metric of winningExperimentMetrics">
                    <div
                      class="percentage"
                      [class.positive]="(experiment[metric] ?? 0) > 0"
                      [class.negative]="(experiment[metric] ?? 0) < 0"
                    >
                      {{
                        experiment[metric] === null
                          ? "—"
                          : (experiment[metric] | number: "1.0-2") + "%"
                      }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="winning-card__actions">
            <button
              type="button"
              class="winning-card__btn winning-card__btn--primary"
              (click)="createCampaign()"
            >
              <mat-icon>add</mat-icon>
              New campaign
            </button>
            <button
              type="button"
              class="winning-card__btn"
              (click)="openNudges()"
            >
              View all nudges
            </button>
          </div>
        </ng-container>

        <!-- No winners in this period: the next step depends on whether
             the target has any campaign yet -->
        <ng-template #noWinningExperiments>
          <div class="winning-empty">
            <span class="winning-empty__icon">
              <mat-icon>{{ hasCampaigns ? "insights" : "auto_awesome" }}</mat-icon>
            </span>

            <ng-container *ngIf="hasCampaigns; else noCampaigns">
              <p class="winning-empty__title">No experiment results for this period</p>
              <p class="winning-empty__text">
                Results from your experiments will appear here.
              </p>
            </ng-container>
            <ng-template #noCampaigns>
              <p class="winning-empty__title">No experiments yet</p>
              <p class="winning-empty__text">
                Experiment results will appear here once a campaign is running.
              </p>
            </ng-template>

            <div class="winning-card__actions">
              <button
                *ngIf="hasCampaigns"
                type="button"
                class="winning-card__btn winning-card__btn--primary"
                (click)="createCampaign()"
              >
                <mat-icon>add</mat-icon>
                Create a campaign
              </button>
              <button
                *ngIf="!hasCampaigns"
                type="button"
                class="winning-card__btn winning-card__btn--primary"
                (click)="getSuggestedNudges()"
              >
                <mat-icon>auto_awesome</mat-icon>
                Get suggested nudges
              </button>
              <button
                type="button"
                class="winning-card__btn"
                (click)="openNudges()"
              >
                View all nudges
              </button>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
  </div>

  <div
    class="card-content"
    *ngIf="!useWinningExperiments && !nudgeDataFirstLoad"
    [ngClass]="{ blur_active: nudge_blurred_show }"
  >
    <!-- <div class="performance-box-orders_content">
      <ng-container>
        <div class="performance-box-orders_table">
          <div class="performance-box-orders_table-header">
            <div class="performance-box-orders_table-item width80">
              <p></p>
            </div>
            <div class="performance-box-orders_table-item width120">
              <p
                matTooltip="{{
                  'phrases.visits_who_have_seen_at_least_one_nudge' | translate
                }}"
                matTooltipPosition="above"
              >
                {{ "phrases.nudges_overall" | translate }}
              </p>
            </div>
            <div class="performance-box-orders_table-item width70">
              <p
                matTooltip="{{
                  'phrases.visits_who_would_have_seen_at_least_one_nudge_but_were_in_control_control_group_sees_no_nudges_at_all'
                    | translate
                }}"
                matTooltipPosition="above"
              >
                {{ "words.control" | translate }}
              </p>
            </div>
            <div class="performance-box-orders_table-item">
              <p>{{ "phrases.revenue_uplift" | translate }}</p>
            </div>
          </div>
          <div class="performance-box-orders_table-body">
            <div class="performance-box-orders_table-row">
              <div class="performance-box-orders_table-item width80">
                <p
                  matTooltip="{{ 'phrases.visit_definition' | translate }}"
                  matTooltipPosition="above"
                >
                  {{ "words.visits" | translate }}
                </p>
              </div>
              <div class="performance-box-orders_table-item width120">
                <p>
                  {{ incentiveBarChart.crorderAmount.incentivesAmount.visits }}
                </p>
              </div>
              <div class="performance-box-orders_table-item width70">
                <p>
                  {{ incentiveBarChart.crorderAmount.controlAmount.visits }}
                </p>
              </div>
              <div class="performance-box-orders_table-item">
                <p
                  [ngClass]="{
                    'uplift-green': revUplift_color === true,
                    'uplift-red': revUplift_color === false,
                    'uplift-none': revUplift_color === 0,
                  }"
                  style="white-space: nowrap"
                >
                  {{ revUplift | currencyFormatter }}
                </p>
              </div>
            </div>
            <div class="performance-box-orders_table-row">
              <div class="performance-box-orders_table-item width80">
                <p>{{ "words.orders" | translate }}</p>
              </div>
              <div class="performance-box-orders_table-item width120">
                <p>
                  {{ incentiveBarChart.crorderAmount.incentivesAmount.orders }}
                </p>
              </div>
              <div class="performance-box-orders_table-item width70">
                <p>
                  {{ incentiveBarChart.crorderAmount.controlAmount.orders }}
                </p>
              </div>
              <div class="performance-box-orders_table-item">
                <p></p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div> -->

    <div class="pov-bar-charts-holder" style="gap: 20px; margin: 0 !important">
      <div class="pov-pageBarChart-container">
        <div class="pov-pageBarChart-axis">
          <h5>{{ "words.cr" | translate }}</h5>
          <div
            class="pov-pageBarChart-axis-inner"
            *ngFor="let axis of barChartCrAxis"
          >
            <p>{{ axis + "%" }}</p>
          </div>
        </div>
        <div class="pov-pageBarChart-main">
          <div
            class="pov-pageBarChart-main-charts"
            *ngFor="let bar of barChartCr; let i = index"
            [ngClass]="{ controlBar: bar.control }"
          >
            <div class="pov-pageBarChart-main-charts-bar-container">
              <div
                class="pov-pageBarChart-main-charts-bar"
                [ngClass]="{ defaultCol: bar.control }"
                [ngStyle]="{ height: bar.height + '%' }"
              >
                <div
                  [ngClass]="{ zeroBarVal: bar.value == 0 }"
                  class="pov-pageBarChart-main-charts-bar-innervalue"
                >
                  <div>{{ bar.value + "%" }}</div>
                  <div *ngIf="!bar.control && bar.diff">
                    {{ "(" + bar.diff + ")" }}
                  </div>
                </div>
                <div
                  class="pov-pageBarChart-main-charts-bar-tooltip"
                  *ngIf="bar.tooltip_translate"
                >
                  <b>{{ ("phrases.sig_control" | translate) + ":" }}</b>
                  {{
                    "phrases.score_with_label"
                      | translate
                        : {
                            value: bar.tooltip_translate?.score,
                            label: (bar.tooltip_translate?.label | translate),
                          }
                  }}
                </div>
              </div>
            </div>
            <div class="pov-pageBarChart-main-charts-name">
              <p>{{ bar.name | translate }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="pov-pageBarChart-container">
        <div class="pov-pageBarChart-axis">
          <h5>{{ "words.rpv" | translate }}</h5>
          <div
            class="pov-pageBarChart-axis-inner"
            *ngFor="let axis of barChartRpvAxis"
          >
            <p>{{ axis | currencyFormatter }}</p>
          </div>
        </div>
        <div class="pov-pageBarChart-main">
          <div
            class="pov-pageBarChart-main-charts"
            *ngFor="let bar of barChartRpv; let i = index"
            [ngClass]="{ controlBar: bar.control }"
          >
            <div class="pov-pageBarChart-main-charts-bar-container">
              <div
                class="pov-pageBarChart-main-charts-bar"
                [ngClass]="{ defaultCol: bar.control }"
                [ngStyle]="{ height: bar.height + '%' }"
              >
                <div
                  [ngClass]="{ zeroBarVal: bar.value == 0 }"
                  class="pov-pageBarChart-main-charts-bar-innervalue"
                >
                  {{ bar.value | currencyFormatter }}
                  <div *ngIf="!bar.control && bar.diff">
                    {{ "(" + bar.diff + ")" }}
                  </div>
                </div>
                <div
                  class="pov-pageBarChart-main-charts-bar-tooltip"
                  *ngIf="bar.tooltip_translate"
                >
                  <b>{{ ("phrases.sig_control" | translate) + ":" }}</b>
                  {{
                    "phrases.score_with_label"
                      | translate
                        : {
                            value: bar.tooltip_translate?.score,
                            label: (bar.tooltip_translate?.label | translate),
                          }
                  }}
                </div>
              </div>
            </div>
            <div class="pov-pageBarChart-main-charts-name">
              <p>{{ bar.name | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Skeleton on first load -->
  <div
    style="display: flex; flex-direction: column; gap: 16px"
    *ngIf="!useWinningExperiments && nudgeDataFirstLoad"
  >
    <div
      class="skeleton-fields"
      style="
        margin: 0 !important;
        padding: 0 !important;
        border-radius: 6px;
        overflow: hidden;
        height: 65px;
      "
    >
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '65px',
          outline: 'none',
          'margin-right': '0px',
          'margin-bottom': '0px',
          'background-color': '#37474f1a',
        }"
      ></ngx-skeleton-loader>
    </div>
    <div style="display: flex; gap: 20px">
      <div
        class="skeleton-fields"
        style="
          margin: 0 !important;
          padding: 0 !important;
          border-radius: 6px;
          overflow: hidden;
          width: 100%;
          height: 200px;
        "
      >
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '200px',
            outline: 'none',
            'margin-right': '0px',
            'margin-bottom': '0px',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div
        class="skeleton-fields"
        style="
          width: 100%;
          margin: 0 !important;
          padding: 0 !important;
          border-radius: 6px;
          overflow: hidden;
          height: 200px;
        "
      >
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '200px',
            outline: 'none',
            'margin-right': '0px',
            'margin-bottom': '0px',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>

  <div
    class="loading-bug-data-overlay"
    *ngIf="!useWinningExperiments && !nudgeDataFirstLoad && nudgeDataLoading"
  >
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
